module.exports = __webpack_public_path__ + "img/email_templates_video.2cdeb60d.png";